import { useCallback, useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Ochiq bo'lim URL'da yashaydi, komponent holatida emas.
 *
 * Sabab `useUrlFilters` bilan bir xil: moderator hamkasbiga "shu
 * odamning chiqarishlariga qara" deb havola tashlaydi va u aynan
 * o'sha bo'limni ochadi. Sahifa yangilanganda ham bo'lim joyida
 * qoladi — bu jadvalning uchinchi sahifasiga chiqib, keyin F5
 * bosgan odam uchun eng sezilarli farq.
 *
 * Yozuv `push` bilan: bo'limni almashtirish — foydalanuvchi
 * QILGAN ish, va "orqaga" tugmasi uni qaytarishi kerak. Filtrlar
 * `replace` ishlatadi, chunki har bosilgan harf tarixga tushsa,
 * "orqaga" bosish qidiruv maydonini bittalab orqaga qaytarardi.
 *
 * Ruxsati yo'q yoki umuman mavjud bo'lmagan bo'lim nomi URL'da
 * turgan bo'lsa (havola eskirgan yoki boshqa huquqli odamdan
 * kelgan), birinchi ochiq bo'lim ko'rsatiladi — xato sahifasi
 * emas: bu yerda ko'rsatadigan narsa bor.
 */
export function useUrlTab(
  tabs: readonly string[],
  options?: { key?: string },
): readonly [string, (next: string) => void] {
  const key = options?.key ?? "tab";
  const [searchParams, setSearchParams] = useSearchParams();

  const value = useMemo(() => {
    const raw = searchParams.get(key);
    if (raw && tabs.includes(raw)) return raw;
    return tabs[0] ?? "";
  }, [searchParams, key, tabs]);

  /**
   * Oxirgi YOZILGAN qiymat.
   *
   * Radix bitta sichqoncha bosishida `onValueChange` ni IKKI marta
   * chaqiradi — `mousedown` da va keyin `focus` da. Ikkalasi ham
   * bitta render doirasida ishlaydi, ya'ni `value` o'zgarishga
   * ulgurmaydi va oddiy `next === value` tekshiruvi ikkinchisini
   * to'xtata olmaydi: tarixga bir xil manzilli ikkita yozuv tushadi
   * va "orqaga" bosgan odam hech narsa o'zgarmaganini ko'radi.
   *
   * `ref` esa darhol yangilanadi, shuning uchun ikkinchi chaqiruv
   * shu yerda to'xtaydi.
   */
  const written = useRef(value);
  useEffect(() => {
    written.current = value;
  }, [value]);

  const setValue = useCallback(
    (next: string) => {
      if (written.current === next) return;
      written.current = next;

      const params = new URLSearchParams(searchParams);
      params.set(key, next);
      // Bo'lim almashganda sahifa raqami tashlanadi: har bir jadval
      // o'z sahifasidan boshlanadi va boshqa bo'limning 3-sahifasi
      // bu yerda bo'sh ro'yxat degani.
      params.delete("page");
      setSearchParams(params);
    },
    [key, searchParams, setSearchParams],
  );

  return [value, setValue] as const;
}
